import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { OverlayComponent } from '@components/atoms/overlay/overlay.component';

import { ModalService } from './services/modal.service';

@Component({
	selector: 'm-modal-container',
	standalone: true,
	templateUrl: './modal-container.component.html',
	styleUrls: ['../../../styles/7-molecules/_modal-container.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, OverlayComponent],
	providers: []
})
export class ModalContainerComponent {
	protected readonly modalService: ModalService = inject(ModalService);

	overlayClicked() {
		if (this.modalService.isClosable()) {
			this.modalService.notifyClose();
		}
	}
}
